import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerActions } from "../../actions/consumer.actions";
import { ContractConsumerFundingDetailsState } from "../../models/mp-admin/contract-consumer-funding-details-state";

const initialState: ContractConsumerFundingDetailsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerActions.contractConsumerFundingDetails.getApi, (state) =>
		_.set(_.cloneDeep(state), "loading", true)
	),
	on(
		ConsumerActions.contractConsumerFundingDetails.getSuccess,
		(state, { contractConsumerFundingDetails, loading }) => ({
			...state,
			contractConsumerFundingDetails,
			loading,
			error: null
		})
	),
	on(
		ConsumerActions.contractConsumerFundingDetails.updateSuccess,
		(state, contractFundingIncrement) => updateState(state, contractFundingIncrement)
	),
	on(
		ConsumerActions.contractConsumerFundingDetails.deleteFileSuccess,
		(state, contractFundingIncrement) => updateState(state, contractFundingIncrement)
	),
	on(ConsumerActions.contractConsumerFundingDetails.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

function updateState(state: ContractConsumerFundingDetailsState, contractFundingIncrement) {
	return {
		...state,
		contractConsumerFundingDetails: state.contractConsumerFundingDetails.map((item) =>
			item.fundingId === contractFundingIncrement.fundingId
				? {
						...item,
						label: contractFundingIncrement.label,
						description: contractFundingIncrement.description,
						files: contractFundingIncrement.files
					}
				: item
		)
	};
}

export function contractConsumerFundingDetailsReducer(
	state: ContractConsumerFundingDetailsState,
	action: Action
): ContractConsumerFundingDetailsState {
	return reducer(state, action);
}
